var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F7F7F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.13 17.859a7.667 7.667 0 00-10.843 0l-2.357 2.356a1 1 0 001.415 1.415l2.356-2.357a5.667 5.667 0 118.014 8.014l-2.357 2.356a1 1 0 001.415 1.415l2.356-2.357a7.667 7.667 0 000-10.842zM21.63 26.344a1 1 0 00-1.414-1.415l-2.357 2.358A7.667 7.667 0 0028.7 38.129l2.358-2.357a1 1 0 00-1.415-1.414l-2.357 2.357a5.667 5.667 0 01-8.014-8.014l2.358-2.357z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.474 24.93a1 1 0 10-1.414-1.415l-7.543 7.543a1 1 0 101.414 1.414l7.543-7.543z",
    fill: "#000"
  })));
}
export default SvgLink;